import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { canAccess } from "../lib/permissions";

export function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-sm text-muted-foreground" data-testid="auth-loading">
        Checking session…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

// A UI guard only; every API remains permission-protected server-side.
export function SectionRoute({ section, children }) {
  const { user } = useAuth();
  if (user === null) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (!canAccess(user, section)) return <Navigate to="/" replace />;
  return children;
}
